function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4605 10.8674C19.4605 10.8674 18.081 11.3412 17.7713 11.6709C17.7713 11.6709 17.7226 12.3512 17.2082 12.8461C16.7796 13.2583 15.8379 13.5844 15.8379 13.5844C15.8379 13.5844 15.9882 11.4427 19.4605 10.8674ZM40.2905 18.6361C40.1766 17.9826 39.9916 17.3789 39.7563 16.822C39.2101 15.5291 38.3903 14.4921 37.5431 13.6835C36.7 12.8788 35.8311 12.3007 35.1773 11.927C34.5395 11.5623 34.1066 11.3904 34.1066 11.3904C34.1183 11.3873 34.1302 11.3851 34.1419 11.3823C34.5543 11.2798 34.977 11.2717 35.3775 11.3139C36.3611 11.4177 37.2041 11.8299 37.3928 11.9274C37.4185 11.9408 37.4323 11.9484 37.4323 11.9484C36.923 11.2768 36.3479 10.6912 35.7476 10.1798C32.9801 7.82245 29.6664 7.07361 29.6664 7.07361C29.6854 7.06407 29.706 7.05565 29.7261 7.04685C30.7436 6.60384 33.3494 7.07361 33.3494 7.07361C33.3319 7.06148 33.3142 7.04963 33.2966 7.03758C29.7846 4.62342 24.4839 4.17948 24.4839 4.17948C18.864 0.401566 20.3416 -1.17355 19.1406 0.958403C18.491 2.11126 18.496 3.18372 18.703 4.02258C18.5847 4.10418 18.5791 4.10798 18.4608 4.18958C16.7075 3.0132 14.1858 1.49709 14.7735 2.34448C15.2196 2.9881 15.6712 4.77124 15.9575 6.07359C11.691 10.3383 13.5061 13.814 13.5061 14.4934C13.5061 15.2272 9.42309 20.1195 9.42309 20.1195C9.42773 20.1254 9.43246 20.1311 9.4371 20.1371C9.43756 20.1376 9.43803 20.1382 9.43849 20.1388C9.47133 20.1782 9.57457 20.3019 9.73932 20.4992C9.81408 20.5833 9.88968 20.6644 9.96584 20.7435C12.6564 23.484 16.1345 22.1246 18.2651 20.8139C20.4692 19.4577 23.3929 19.9352 24.9217 22.0214C25.0388 22.181 25.1558 22.358 25.2694 22.5513C26.1515 24.0518 26.2218 26.0113 25.6364 27.9234C23.656 34.3939 15.5709 36.4465 10.4425 32.0243C8.30003 30.1767 7.13969 27.9679 6.52672 26.3358C5.6313 23.5501 5.15534 20.6039 5.15534 17.5841V14.7185L11.5487 11.9662C11.5171 11.2605 11.5863 10.3646 11.8948 9.32468C12.1908 8.32641 12.7072 7.19541 13.5686 5.97115L0.441406 11.622V17.5841C0.441406 29.876 7.1831 41.1331 18.0352 46.9622L19.9657 47.9995L21.8959 46.9622C32.1999 41.4276 38.7946 30.9992 39.4349 19.4386C39.4646 18.902 39.4822 18.363 39.486 17.8217L39.4823 17.8202C39.4825 17.8197 39.4827 17.8191 39.4828 17.8187C39.9878 18.2554 40.2905 18.6361 40.2905 18.6361Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 19,
  width: 2,
  height: 2
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.49805 19.9238C9.79324 20.2542 10.0954 20.5555 10.4037 20.8295C10.2729 20.711 10.1431 20.5896 10.0147 20.4637C9.73175 20.1681 9.55444 19.9828 9.49805 19.9238Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.49805 19.9238C9.79324 20.2542 10.0954 20.5555 10.4037 20.8295C10.2729 20.711 10.1431 20.5896 10.0147 20.4637C9.73175 20.1681 9.55444 19.9828 9.49805 19.9238Z",
  fill: "url(#paint0_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 19,
  y: 0,
  width: 5,
  height: 6
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.6093 4.28188C20.8763 3.38611 19.9383 0.905273 19.9383 0.905273C19.0002 2.7658 19.732 4.28188 19.732 4.28188C20.8437 6.34918 24.3423 5.17775 22.6093 4.28188Z",
  fill: "white"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.6093 4.28188C20.8763 3.38611 19.9383 0.905273 19.9383 0.905273C19.0002 2.7658 19.732 4.28188 19.732 4.28188C20.8437 6.34918 24.3423 5.17775 22.6093 4.28188Z",
  fill: "#C1B9D3"
}));

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "mask2",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 25,
  y: 6,
  width: 9,
  height: 2
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.8 6.66421C25.8 6.66421 28.2129 7.12338 29.3979 7.21171C29.4252 7.21375 29.4545 7.21648 29.4847 7.21949C30.4846 6.79698 33.0453 7.24502 33.0453 7.24502C33.0281 7.23344 33.0107 7.22214 32.9934 7.21065C29.9371 5.64783 25.8 6.66421 25.8 6.66421Z",
  fill: "white"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.8 6.66421C25.8 6.66421 28.2129 7.12338 29.3979 7.21171C29.4252 7.21375 29.4545 7.21648 29.4847 7.21949C30.4846 6.79698 33.0453 7.24502 33.0453 7.24502C33.0281 7.23344 33.0107 7.22214 32.9934 7.21065C29.9371 5.64783 25.8 6.66421 25.8 6.66421Z",
  fill: "#C1B9D3"
}));

var _ref9 = /*#__PURE__*/React.createElement("mask", {
  id: "mask3",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 29,
  y: 9,
  width: 8,
  height: 3
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5404 9.07311C26.8449 8.8338 33.4986 11.2065 33.4986 11.2065C33.4986 11.2065 33.51 11.2089 33.5303 11.2128C33.9254 11.1082 34.3303 11.0999 34.714 11.143C35.6563 11.249 36.4639 11.6698 36.6447 11.7694C36.6524 11.7707 36.6602 11.7719 36.6681 11.7731C36.6681 11.7731 34.2358 9.31242 30.5404 9.07311Z",
  fill: "white"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5404 9.07311C26.8449 8.8338 33.4986 11.2065 33.4986 11.2065C33.4986 11.2065 33.51 11.2089 33.5303 11.2128C33.9254 11.1082 34.3303 11.0999 34.714 11.143C35.6563 11.249 36.4639 11.6698 36.6447 11.7694C36.6524 11.7707 36.6602 11.7719 36.6681 11.7731C36.6681 11.7731 34.2358 9.31242 30.5404 9.07311Z",
  fill: "#C1B9D3"
}));

var _ref11 = /*#__PURE__*/React.createElement("mask", {
  id: "mask4",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 34,
  y: 15,
  width: 7,
  height: 5
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.4183 18.2463C39.4185 18.2459 39.4187 18.2453 39.4188 18.2448C39.9639 18.6975 40.2907 19.0921 40.2907 19.0921C40.2907 19.0921 38.9254 15.7932 34.8567 15.3958L39.3671 19.9241C39.3992 19.3678 39.4182 18.8091 39.4223 18.248L39.4183 18.2463Z",
  fill: "white"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask4)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.4183 18.2463C39.4185 18.2459 39.4187 18.2453 39.4188 18.2448C39.9639 18.6975 40.2907 19.0921 40.2907 19.0921C40.2907 19.0921 38.9254 15.7932 34.8567 15.3958L39.3671 19.9241C39.3992 19.3678 39.4182 18.8091 39.4223 18.248L39.4183 18.2463Z",
  fill: "#C1B9D3"
}));

var _ref13 = /*#__PURE__*/React.createElement("mask", {
  id: "mask5",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 19,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.53782 19.9624C9.53847 19.9633 9.5429 19.9688 9.55067 19.9777C9.54521 19.9712 9.53801 19.9627 9.53782 19.9623C9.53782 19.9623 9.53782 19.9623 9.53782 19.9624Z",
  fill: "white"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.53782 19.9624C9.53847 19.9633 9.5429 19.9688 9.55067 19.9777C9.54521 19.9712 9.53801 19.9627 9.53782 19.9623C9.53782 19.9623 9.53782 19.9623 9.53782 19.9624Z",
  fill: "url(#paint1_linear)"
}));

var _ref15 = /*#__PURE__*/React.createElement("mask", {
  id: "mask6",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 20,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.43586 20.1358C9.43642 20.1365 9.43753 20.1379 9.43827 20.1387C9.4378 20.1381 9.43734 20.1375 9.43688 20.137C9.4366 20.1367 9.43614 20.1361 9.43586 20.1358Z",
  fill: "white"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.43586 20.1358C9.43642 20.1365 9.43753 20.1379 9.43827 20.1387C9.4378 20.1381 9.43734 20.1375 9.43688 20.137C9.4366 20.1367 9.43614 20.1361 9.43586 20.1358Z",
  fill: "url(#paint2_linear)"
}));

var _ref17 = /*#__PURE__*/React.createElement("mask", {
  id: "mask7",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 9,
  width: 33,
  height: 34
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.3125 42.4016C20.3433 42.4448 20.3619 42.47 20.3619 42.47L21.0268 42.1129C23.0027 41.0056 30.0321 35.1591 31.3137 29.8722C33.578 20.5328 28.2368 18.9692 28.2368 18.9692C32.6875 19.1206 34.3738 23.1606 34.3738 23.1606C34.3738 23.1606 33.5979 17.1006 28.0345 15.535C22.471 13.9696 19.8916 18.2116 15.3903 20.1196C11.1361 21.9228 9.59355 20.3188 9.43687 20.1371C9.43734 20.1377 9.4378 20.1382 9.43827 20.1389C9.4711 20.1782 9.57435 20.302 9.73909 20.4993C9.81386 20.5834 9.88946 20.6644 9.96561 20.7435C12.6561 23.4841 16.1343 22.1247 18.2649 20.8139C20.469 19.4577 23.3927 19.9352 24.9215 22.0215C25.0386 22.1811 25.1556 22.3581 25.2692 22.5514C26.1513 24.0518 26.2215 26.0113 25.6362 27.9235C23.6558 34.394 15.5707 36.4466 10.4423 32.0244C8.29981 30.1768 7.13946 27.9679 6.52649 26.3359C5.63107 23.5501 5.15511 20.6039 5.15511 17.5841V14.7185L11.5485 11.9663C11.5169 11.2606 11.5861 10.3647 11.8946 9.32471L2.97578 12.9798C2.97578 12.9798 0.0919349 37.7242 20.3125 42.4016Z",
  fill: "white"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask7)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.9205 41.8606C22.8964 40.7532 30.0302 35.1591 31.3119 29.8722C33.5762 20.5328 28.2349 18.9692 28.2349 18.9692C32.6857 19.1206 34.372 23.1606 34.372 23.1606C34.372 23.1606 33.596 17.1006 28.0327 15.535C22.4691 13.9696 19.8897 18.2116 15.3884 20.1196C11.1342 21.9228 9.59167 20.3188 9.435 20.1371C9.43546 20.1377 9.43592 20.1382 9.43639 20.1389C9.46922 20.1782 9.57247 20.302 9.73721 20.4993C9.81198 20.5834 9.88758 20.6644 9.96373 20.7435C12.6543 23.4841 16.1324 22.1247 18.263 20.8139C20.4671 19.4577 23.3908 19.9352 24.9196 22.0215C25.0367 22.1811 25.1537 22.3581 25.2673 22.5514C26.1494 24.0518 26.2197 26.0113 25.6343 27.9235C23.6539 34.394 15.5688 36.4466 10.4404 32.0244C8.29793 30.1768 7.13758 27.9679 6.52462 26.3359C5.62919 23.5501 5.15324 20.6039 5.15324 17.5841V14.7185L11.5466 11.9663C11.515 11.2606 11.5842 10.3647 11.8927 9.32471L2.97391 12.9798C2.97391 12.9798 -0.567457 37.6914 19.6531 42.3688C19.8556 42.47 20.9205 41.8606 20.9205 41.8606Z",
  fill: "#C1B9D3"
}));

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -14.4135,
  y1: -8.88306,
  x2: -20.9605,
  y2: 46.0413,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -6.97755,
  y1: 1.04656,
  x2: -10.7745,
  y2: 37.6244,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 0.850687,
  y1: 2.03178,
  x2: -1.29845,
  y2: 22.738,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080"
})));

var SvgShukiLogo = function SvgShukiLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShukiLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shukiLogo.2fb7c012.svg";
export { ForwardRef as ReactComponent };